import { Injectable, Output, EventEmitter } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class PhotoCarouselService {
  imageIndex = 0;

  @Output()
  updateImageIndex: EventEmitter<number> = new EventEmitter();

  constructor() {}

  setImageIndex(index) {
    this.imageIndex = index;
    this.updateImageIndex.emit(this.imageIndex);
  }
}
